const API_TYPES = {
  GET: 'GET',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
  POST: 'POST',
};

const VOICE_CHANNEL_BASE_API_URL = '/v1/integrations';

const VOICE_CHANNEL_INBOX_URL = `${VOICE_CHANNEL_BASE_API_URL}/channels/inboxes`;

const CREATE_VOICE_CHANNEL_INBOXES = {
  type: API_TYPES.POST,
  url: VOICE_CHANNEL_INBOX_URL,
};

const GET_VOICE_INBOX_DETAILS = {
  type: API_TYPES.GET,
  url: VOICE_CHANNEL_INBOX_URL,
};

const UPDATE_VOICE_INBOX_DETAILS = {
  type: API_TYPES.PATCH,
  url: VOICE_CHANNEL_INBOX_URL,
};

const REAUTH_VOICE_INBOX = {
  type: API_TYPES.PATCH,
  url: `${VOICE_CHANNEL_INBOX_URL}/:voiceInboxId/reauth`,
}

const CHANNEL_NAME = {
  AIRCALL: 'aircall',
};

const CHANNEL_TITLE = {
  AIRCALL : 'Voice',
};


export {
  CREATE_VOICE_CHANNEL_INBOXES,
  CHANNEL_NAME,
  GET_VOICE_INBOX_DETAILS,
  UPDATE_VOICE_INBOX_DETAILS,
  CHANNEL_TITLE,
  REAUTH_VOICE_INBOX,
};
